import { Component, Input, HostBinding } from '@angular/core';
import { NavItemBaseComponent } from './_nav-item-base.component';


@Component({
  moduleId: module.id,
  selector: 'nav-item, [bsNavItem]',
  templateUrl: 'nav-item.component.html',
  styleUrls: ['nav-item.component.scss']
})
export class NavItemComponent extends NavItemBaseComponent {
  @Input() ghostValue: string;

  @HostBinding('class.version2')
  @Input() isVersion2: boolean = false;

  @HostBinding('class.nav-item') navItem: boolean = true;

  onClick(event: MouseEvent) {
    event.preventDefault();
    this.navService.selectNav(this);
  }
}
